import { z } from 'zod';

export const habitFormSchema = z
  .object({
    name: z
      .string()
      .trim()
      .min(1, 'Name is required')
      .max(40, 'Name must be 40 characters or fewer'),
    icon: z.string().min(1, 'Pick an icon'),
    color: z.string().min(1, 'Pick a color'),
    frequency: z.enum(['daily', 'weekdays', 'weekends', 'custom']),
    customDays: z.array(z.number().int().min(0).max(6)).optional(),
    scheduledTime: z
      .string()
      .regex(/^\d{2}:\d{2}$/, 'Use HH:MM')
      .optional(),
    durationMinutes: z
      .number()
      .int()
      .min(1, 'At least 1 minute')
      .max(180, 'At most 180 minutes')
      .optional(),
  })
  .refine(
    (v) => v.frequency !== 'custom' || (v.customDays !== undefined && v.customDays.length > 0),
    { path: ['customDays'], message: 'Pick at least one day' },
  )
  .refine((v) => !v.scheduledTime || (v.durationMinutes !== undefined && v.durationMinutes > 0), {
    path: ['durationMinutes'],
    message: 'Pick a duration for this habit',
  });

export type HabitFormValues = z.infer<typeof habitFormSchema>;
